import { jsx as _jsx } from "react/jsx-runtime";
import { SheetAlignmentEnum } from '@inter-ikea-kompis/enums';
import { KompisStoreSelectorCard } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { SkapaModalBody, SkapaModalHeader, SkapaSheet } from '@inter-ikea-guida/skapa';
export const StoreAvailabilitySheet = ({ storeId, stores, onStoreChange, visible, closeStoreSelector, kompisTranslations }) => {
    const handleChange = (e) => {
        const storeId = e.detail.storeId;
        onStoreChange(storeId);
        closeStoreSelector();
    };
    return (_jsx(SkapaSheet, { header: _jsx(SkapaModalHeader, {}), footer: null, visible: visible, handleCloseBtn: closeStoreSelector, dataTestId: 'store-availability-sheet', alignment: SheetAlignmentEnum.left, children: _jsx(SkapaModalBody, { children: _jsx(KompisStoreSelectorCard, { theme: SkapaTheme, stores: stores, storeId: storeId, translations: kompisTranslations, onChange: handleChange }) }) }));
};
//# sourceMappingURL=StoreAvailabilitySheet.js.map